//requestIdleCallback shim
//found here: https://gist.github.com/paullewis/55efe5d6f05434a96c36
window.requestIdleCallback = window.requestIdleCallback ||
    function(cb) {
        return setTimeout(function() {
                var start = Date.now();
                cb({
                    didTimeout: false,
                    timeRemaining: function() {
                        return Math.max(0, 50 - (Date.now() - start));
                    }
                });
            },
            1);
    }

window.cancelIdleCallback = window.cancelIdleCallback ||
    function(id) {
        clearTimeout(id);
    }

//defined in head.cshtml
var evo = evo || {};

//we use this to store jquery Objects globally, gets set in the init (infrequently)
evo.$ = {};

//store all the same media queries declared in LESS in JS.
evo.mq = {
    screenXsMin: 480,
    screenSmMin: 768,
    screenMdMin: 1024,
    screenLgMin: 1200,
    navigationBreakpoint: 925
};

evo.isMobile = false;
evo.isMobileNavigation = false;

evo.iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);

evo.windowWidth = 0;
evo.bodyHeight = 0;

String.prototype.format = String.prototype.f = function () {
    var args = arguments;
    return this.replace(/\{\{|\}\}|\{(\d+)\}/g, function (m, n) {
        if (m == "{{") { return "{"; }
        if (m == "}}") { return "}"; }
        return args[n];
    });
};
String.prototype.splice = function (start, delCount, newSubStr) {
    return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
};
function escapeSingleQuotes(str) {
    return (str || '').replace(/'/g, "\\\'");
}
function GetDateObject(jsonDate) {
    if (!jsonDate) {
        return null;
    }
    if (typeof jsonDate === 'object') {
        return jsonDate;
    }
    return new Date(parseInt(jsonDate.replace(/\/Date\((\d+)\)\//, '$1')));
}

function fuzepopup(url, windowName) {
    var mywin = window.open(url, windowName || "popup", 'height=600, width=1000, toolbar=yes, menubar=yes, scrollbars=yes, resizable=yes, location=yes, directories=yes, status=yes');
    mywin.focus();
}

function ClearSingleQuotes(str) {
    return (str || '').replace(/'/g, "\\\'");
}

//sets up window width variables and mobile
function setWindowVariables() {
    evo.windowWidth = evo.$.window.width();
    evo.bodyHeight = evo.$.body.height();
    evo.isMobile = evo.windowWidth < evo.mq.screenSmMin;
    evo.isMobileNavigation = evo.windowWidth < evo.mq.navigationBreakpoint;
}

function AppendQueryString(param) {
    var loc = window.location,
        newLoc = loc.protocol + '//' + loc.host + loc.pathname;
    if (loc.search) {
        newLoc += loc.search + '&';
    }
    else {
        newLoc += '?';
    }
    newLoc += param;
    window.location.href = newLoc;
    return false;
}

(function ($) {
    var appPath = null;
    $.ApplicationPath = function () {
        if (appPath === null) {
            //cache the base url
            appPath = $('#app-root').attr('value');
            if (appPath.indexOf('/', appPath.length - 1) !== -1) {
                appPath = appPath.substr(0, appPath.length - 1);
            }
        }
        return appPath;
    };

    evo.ajax = function (page, method, dataObj, cache) {
        /// <summary>
        /// Returns a jQuery promise object that is configured to talk to an aspx static ScriptMethod
        /// </summary>
        /// <param name="page"></param>
        /// <param name="method"></param>
        /// <param name="data"></param>

        return $.ajax({
            type: "POST",
            cache: cache || false,
            url: $.ApplicationPath() + page + '/' + method,
            data: JSON.stringify(dataObj),
            contentType: "application/json;charset=utf-8",
            dataType: "json"
        });
    };

    evo.trackGAEvent = function (category, event, label, value, nonInteractive) {
        /// <summary>
        /// Track a Google Analytics event
        /// </summary>
        /// <param name="category"></param>
        /// <param name="event"></param>
        /// <param name="label"></param>
        /// <param name="value"></param>
        /// <param name="nonInteractive"></param>

        if (typeof _gaq !== 'undefined') {
            _gaq.push(['_trackEvent', category, event, label, value, nonInteractive]);
        }
        dataLayerManager.pushEvent(category, event, label, value, nonInteractive);
    }

    var _loadingScripts = {};
    evo.loadScript = function (url) {
        /// <summary>
        /// Load external javascript file if it hasn't already been loaded
        /// </summary>
        /// <param name="url">the url of the script</param>
        /// <returns>jQuery deferred object</returns>
        if ($('script[src="' + url + '"]').length) {
            _loadingScripts[url] = $.Deferred().resolve();
        }
        return _loadingScripts[url] || (_loadingScripts[url] = $.getScript(url));
    }

    $('img[usemap]').rwdImageMaps();

    //if the hash parameter contains 'compareids', redirect the user to the compare tool
    var indexOfCompareIds = window.location.hash.indexOf('compareids');
    if (indexOfCompareIds >= 0) {
        var newLocation = $.ApplicationPath() + '/compare?compareids=' + window.location.hash.substr(indexOfCompareIds + 11);
        newLocation += '&url=' + encodeURIComponent(window.location.pathname + window.location.search);
        var indexOfBar = document.title.indexOf(' | ');
        newLocation += '&title=' + encodeURIComponent(document.title.substr(0, indexOfBar));
        window.location = newLocation;
    }

    $(document.body).on('keydown', 'input', function (e) {
        if (e.which === 13) {
            var catcher = $(this).closest('.enterKeyCatcher');
            if (catcher.size() > 0) {
                var btn = catcher.find('.default');
                if (btn.size() > 0) {
                    if (btn.is('a') && btn.attr('href').indexOf('javascript:') === 0) {
                        window.location.replace(btn.attr('href'));
                    } else {
                        btn.click();
                    }
                    return false;
                }
            }
        }
    });

    // parseUri 1.2.2
    // (c) Steven Levithan <stevenlevithan.com>
    // MIT License
    var parseUriOptions = {
        strictMode: false,
        key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
        q: {
            name: "queryKey",
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        },
        parser: {
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }
    };
    $.parseUri = function (str) {
        if (typeof str === 'undefined') {
            str = window.location.href;
        }
        var o = parseUriOptions,
            m = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
            uri = {},
            i = 14;

        while (i--) uri[o.key[i]] = m[i] || "";

        uri[o.q.name] = {};
        uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
            if ($1) uri[o.q.name][$1] = $2;
        });

        return uri;
    }

    if (evo) {
        if (evo.scripts) {
            function getScripts() {
                if (evo.scripts.length) {
                    $.getScript(evo.scripts.shift(), getScripts);
                } else {
                    var numberOfHolds = 0;
                    function fireReady() {
                        if (evo._ready.length) {
                            $(evo._ready.shift());
                            fireReady();
                        } else {
                            evo.ready = function (doThisOnReady) {
                                if ($.isFunction(doThisOnReady)) {
                                    if (numberOfHolds > 0) {
                                        evo._ready.push(doThisOnReady);
                                    } else {
                                        $(doThisOnReady);
                                    }
                                }
                            };
                        }
                    }
                    evo.holdReady = function (addHold) {
                        if (addHold) {
                            numberOfHolds++;
                        } else if (numberOfHolds > 0) {
                            numberOfHolds--;
                            if (numberOfHolds === 0) {
                                fireReady();
                            }
                        }
                    };
                    evo.scripts.push = function (script) {
                        evo.holdReady(true);
                        $.getScript(script, evo.holdReady);
                    };
                    if (evo._ready) {
                        fireReady();
                    }
                }
            }
            getScripts();
        }
    }

    //required for smerch's simulator
    $.postWindowInfo = function (firedRules) {
        if (window.top) {
            var elementsThatControlHeight = $(document.body).children('header,form');
            function calculatePageHeight() {
                var h = 0;
                elementsThatControlHeight.each(function () {
                    h += $(this).height();
                });
                return h || evo.bodyHeight;
            }

            //periodically check the page height and report changes to the simulator
            var height = calculatePageHeight();
            function reportHeightChanges() {
                var currentHeight = calculatePageHeight();
                if (height !== currentHeight) {
                    height = currentHeight;
                    parent.postMessage(JSON.stringify({
                        m: 'Resize',
                        h: height
                    }), '*');
                }
                window.setTimeout(reportHeightChanges, 500);
            }
            window.setTimeout(reportHeightChanges, 500);

            //when the page first loads, this is the 'url change' event that needs to get sent
            var cookieIndex = document.cookie.indexOf('smerch='),
                msg = {
                    h: calculatePageHeight(),
                    m: (cookieIndex > -1 && document.cookie.substr(cookieIndex + 7, 6) === 'Staged') ? 'Staged' : 'Live',
                    u: location.href
                };
            if (typeof firedRules !== 'undefined' && $.isArray(firedRules)) {
                msg.r = $.map(firedRules, function (rule) {
                    return {
                        name: rule.name || rule.Name,
                        dateModified: rule.dateModified || rule.DateModified,
                        status: rule.status || rule.Status,
                        ruleId: rule.ruleId || rule.RuleId
                    };
                });
            }
            parent.postMessage(JSON.stringify(msg), '*');
        }
    }

    //set up window and mobile variables
    evo.$.body = $(document.body);
    evo.$.html = $('html');
    evo.$.window = $(window);
    $(function () {
        setWindowVariables();

        evo.$.window.on('resize', function () {
            setWindowVariables();
        });

        window.setTimeout(function () {
            if (typeof _firedRules !== 'undefined') {
                $.postWindowInfo(_firedRules);
            } else {
                $.postWindowInfo();
            }
        }, 15);
    });

    //Handle mobile click for culture dropdown
    var cultureDropdown = document.getElementById("culture-dropdown-mobile");
    if (cultureDropdown) {
        cultureDropdown.addEventListener("click",
            function () {
                var dropdownContent = document.getElementById("culture-dropdown-mobile")
                    .getElementsByClassName("masthead-action-menu")[0];
                if (dropdownContent.style.display === 'block') {
                    dropdownContent.style.display = 'none';
                } else {
                    dropdownContent.style.display = 'block';
                }
            },
            false);
    };

    $(window).load(function () {
        //set webkit class for selects
        if (navigator.userAgent.indexOf('WebKit') > 0) {
            evo.$.body.addClass('webkit');
        }
    });

    //trigger loading of the icon font from CSS so we are loading the font files async. See fonts.less.
    $('body').addClass('load-icons');
})(jQuery);